<template>
  <div class="document-download">
    <div style="flex: 8">
      <p class="file-details">
        <span class="file-type">{{ document.docType }}</span>
        <br />
        <span class="filename text-normal text-unbold">
          {{ document.filename }}
        </span>
      </p>
    </div>
    <div style="flex: 4">
      <md-button class="md-raised" style="position:relative">
        <translate>Download</translate>
        <a :href="document.file" class="btn-link" target="_blank" rel="noreferrer noopener"></a>
      </md-button>
    </div>
  </div>
</template>

<script>
/**
 * Document Download Component
 *
 * Displays a document's name and a download button.
 *
 * @prop {Document} document - The document to display
 */
export default {
  name: 'DocumentDownload',
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '../styles/variables';

.document-download {
  display: flex;
  border-top: 1px solid $soft-gray;
  padding: 1rem 0;

  &:hover {
    background-color: $off-white;
  }
}

.btn-link {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
</style>
